import React from 'react';
import AutomationRuleItem from './AutomationRuleItem';

const CATEGORY_MAP = {
  card_created: 'Auto-assign',
  card_moved_to_list: 'Auto-status',
  card_moved_from_list: 'Auto-status',
  due_date_approaching: 'Due Date',
  due_date_passed: 'Due Date',
  checklist_completed: 'Auto-status',
  label_added: 'Auto-assign',
  priority_changed: 'Auto-status',
  schedule: 'Scheduled'
};

const AutomationList = ({ automations, boardId, isAdmin }) => {
  // Group automations by category
  const grouped = automations.reduce((acc, automation) => {
    const category = CATEGORY_MAP[automation.trigger?.type] || 'Other';
    if (!acc[category]) acc[category] = [];
    acc[category].push(automation);
    return acc;
  }, {});

  const categoryOrder = ['Auto-assign', 'Due Date', 'Auto-status', 'Scheduled', 'Other'];
  const sortedCategories = categoryOrder.filter(cat => grouped[cat]?.length > 0);

  return (
    <div className="automation-list">
      {sortedCategories.map(category => (
        <div key={category} className="automation-category">
          <div className="category-header">
            <h3>{category}</h3>
            <span className="category-count">{grouped[category].length}</span>
          </div>
          <div className="category-rules">
            {grouped[category].map(automation => (
              <AutomationRuleItem
                key={automation._id}
                automation={automation}
                boardId={boardId}
                isAdmin={isAdmin}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AutomationList;
